// extracted by mini-css-extract-plugin
export default {"titleText":"ConfirmAlertBox_titleText__lMCDR","contentText":"ConfirmAlertBox_contentText__a5kHX"};